import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Clock, Gift, CheckCircle2, Smartphone, ArrowUpRight } from "lucide-react";
import { handleAffiliateClick, gaEvent } from "@/lib/tracking";

const PAGE_TITLE = "Ghid complet PU Prime - Activare bonus 100% și verificare cont";
const PAGE_DESC =
  "Urmează pas cu pas procesul de creare cont PU Prime, verificare identitate și activare bonus 100%.";

/* Screenshot mapping. Replace placeholder URLs (null) with real asset
   URLs as the user uploads them. Each step may have one or two images. */
const STEPS = [
  {
    n: 1,
    title: "Creează contul",
    desc: "Accesează formularul de înregistrare și completează datele de bază: țara, numele, emailul și parola contului.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/roqe849q_1.png"],
  },
  {
    n: 2,
    title: "Completează informațiile personale",
    desc: "Introdu datele personale exact așa cum apar în actul tău de identitate.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/euzurf75_2.png"],
  },
  {
    n: 3,
    title: "Configurează contul de tranzacționare",
    desc: "Selectează MetaTrader 5 ca platformă și alege tipul Standard pentru început.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/g3nhjcp5_3.png"],
    badges: ["MetaTrader 5", "Standard Account", "USD"],
  },
  {
    n: 4,
    title: "Finalizarea creării contului",
    desc: "Contul a fost creat cu succes și poți continua către verificarea identității.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/bzyfm1ie_4.png"],
  },
  {
    n: 5,
    title: "Începe verificarea identității",
    desc: "Pentru activarea completă a contului este necesară verificarea identității.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/v9wmogdr_5.png"],
  },
  {
    n: 6,
    title: "Continuă verificarea pe telefon",
    desc: "Apasă Continue on phone și scanează codul QR cu telefonul.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/3ilt0lhy_6.png"],
    callout: {
      icon: Smartphone,
      text: "Recomandat: efectuează verificarea direct de pe telefon.",
    },
  },
  {
    n: 7,
    title: "Confirmă țara de rezidență",
    desc: "Selectează opțiunea pentru toate țările în afară de SUA și continuă procesul.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/wp93m7jt_7.jpeg"],
  },
  {
    n: 8,
    title: "Completează informațiile personale",
    desc: "Verifică și completează toate câmpurile cerute.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/vzm1qxxf_8.jpeg"],
  },
  {
    n: 9,
    title: "Selectează documentul",
    desc: "Pentru România recomandăm utilizarea cărții de identitate.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/q9eezjv3_9.jpeg"],
    badges: ["Carte de identitate"],
  },
  {
    n: 10,
    title: "Încarcă documentul",
    desc: "Fotografiază sau încarcă documentul astfel încât toate informațiile să fie clare și lizibile.",
    images: [
      "https://customer-assets.emergentagent.com/job_putrade-community/artifacts/qu7arx4l_10.jpeg",
      "https://customer-assets.emergentagent.com/job_putrade-community/artifacts/t9y9owrp_11.jpeg",
    ], // screenshots 10 + 11
  },
  {
    n: 11,
    title: "Așteaptă verificarea",
    desc: "Platforma verifică automat informațiile și documentele încărcate.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/0ylret1m_12.jpeg"],
  },
  {
    n: 12,
    title: "Cont verificat",
    desc: "Felicitări! Contul tău este acum verificat.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/uezqat1q_13.jpeg"],
  },
  {
    n: 13,
    title: "Accesează secțiunea Promotions",
    desc: "Din meniul din stânga accesează Promotions și selectează oferta 100% Deposit Bonus.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/o3ritoy0_15.png"],
  },
  {
    n: 14,
    title: "Activează bonusul",
    desc: "Bifează termenii și condițiile și apasă Opt-In Now.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/b5755b94_pasul%2014.png"],
  },
  {
    n: 15,
    title: "Confirmă activarea bonusului",
    desc: "Dacă vezi acest mesaj, bonusul a fost activat cu succes.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/00aq4820_17.png"],
  },
  {
    n: 16,
    title: "Confirmarea prin email",
    desc: "Vei primi și un email de confirmare privind activarea bonusului.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/j533lei6_17.1.jpeg"], // screenshot 17.1
  },
  {
    n: 17,
    title: "Depune fonduri",
    desc: "Accesează secțiunea Funds și introdu suma pe care dorești să o depui.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/t2ywia6w_18.png"],
  },
  {
    n: 18,
    title: "Selectează metoda de plată",
    desc: "Alege metoda de depunere preferată și finalizează alimentarea contului.",
    images: [
      "https://customer-assets.emergentagent.com/job_putrade-community/artifacts/c7jp9p4c_19.png",
      "https://customer-assets.emergentagent.com/job_putrade-community/artifacts/qmi1tnxm_20.png",
    ],
  },
  {
    n: 19,
    title: "Confirmă plata",
    desc: "După ce ai ales metoda de plată și ai introdus suma dorită, verifică detaliile tranzacției, bifează termenii și apasă „Pay Now” pentru a finaliza depunerea.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/h4ccg36n_20.png"],
  },
  {
    n: 20,
    title: "Depunere efectuată cu succes",
    desc: "După finalizarea plății, vei primi confirmarea depunerii. În exemplul de mai jos, depunerea este de 500 USD, iar fondurile urmează să apară în cont.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/3ojtsyja_20.1.jpeg"],
  },
  {
    n: 21,
    title: "Primești confirmarea depunerii pe email",
    desc: "PU Prime îți trimite automat un email prin care confirmă că depunerea a fost procesată cu succes.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/g6i23919_21.jpeg"],
  },
  {
    n: 22,
    title: "Primești confirmarea bonusului de 100%",
    desc: "După procesarea depunerii, dacă promoția este activă și condițiile sunt îndeplinite, bonusul de 100% este creditat în cont. Vei primi și un email separat de confirmare.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/dki1ps8w_22.jpeg"],
  },
  {
    n: 23,
    title: "Verifică soldul total",
    desc: "După ce depunerea și bonusul sunt creditate, soldul total se actualizează în portal. În exemplu: 500 USD depunere + 500 USD bonus = 1.000 USD total.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/lycmii6a_23.jpeg"],
  },
  // ---- MT5 connection section starts here (internal labels restart from "Pasul 1") ----
  {
    n: 24,
    displayLabel: "Pasul 1",
    title: "Primești datele contului MT5",
    desc: "PU Prime îți trimite un email cu datele de conectare pentru MetaTrader 5: login, parolă și server. Aceste date sunt necesare pentru autentificarea în aplicație.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/np2nt76z_Meta%20Trader%201.jpeg"],
  },
  {
    n: 25,
    displayLabel: "Pasul 2",
    title: "Instalează aplicația MetaTrader 5",
    desc: "Descarcă aplicația MetaTrader 5 din App Store sau Google Play, apoi deschide aplicația pentru a conecta noul cont.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/g0f5ju6p_Meta%20Trader%202.PNG"],
  },
  {
    n: 26,
    displayLabel: "Pasul 3",
    title: "Accesează New Account",
    desc: "În aplicația MetaTrader 5, mergi la Settings și apasă pe „New Account” pentru a adăuga contul primit de la PU Prime.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/lb63r2eh_Meta%20Trader%203%282%29.png"],
  },
  {
    n: 27,
    displayLabel: "Pasul 4",
    title: "Caută PU Prime",
    desc: "În bara de căutare scrie „PU Prime”, apoi selectează „PU Prime Ltd” din lista de rezultate.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/3707ojkl_Meta%20Trader%204.PNG"],
  },
  {
    n: 28,
    displayLabel: "Pasul 5",
    title: "Conectează contul MT5",
    desc: "Completează câmpurile Login, Password și Server exact cum apar în emailul primit de la PU Prime. După completare, apasă „Sign In”.",
    images: ["https://customer-assets.emergentagent.com/job_putrade-community/artifacts/24hx0sv3_Meta%20Trader%205.PNG"],
  },
];

// Step number BEFORE which the MT5 section divider should appear.
const MT5_DIVIDER_BEFORE_STEP = 24;

/* ---------- SEO head ---------- */
function useDocumentMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc ? metaDesc.getAttribute("content") : null;
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc !== null) metaDesc.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}

/* ---------- Screenshot block (real image or numbered placeholder) ---------- */
const Screenshot = ({ src, label }) => {
  if (src) {
    return (
      <div className="mx-auto max-w-[60%] md:max-w-none rounded-2xl overflow-hidden bg-neutral-50 border border-black/[0.06] shadow-[0_10px_30px_-15px_rgba(17,24,39,0.18)]">
        <img
          src={src}
          alt={label}
          loading="lazy"
          decoding="async"
          className="w-full h-auto block"
        />
      </div>
    );
  }
  return (
    <div className="mx-auto max-w-[60%] md:max-w-none rounded-2xl bg-neutral-50 border border-dashed border-black/15 aspect-[4/3] flex flex-col items-center justify-center p-6 text-center">
      <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-black/40">
        Screenshot
      </span>
      <span className="mt-2 font-display text-2xl font-extrabold text-black/20">
        {label}
      </span>
      <span className="mt-2 text-[11px] text-black/35 max-w-[20ch]">
        În curând
      </span>
    </div>
  );
};

/* ---------- Step row ---------- */
const StepRow = ({ step, reverse }) => {
  const Callout = step.callout?.icon;
  return (
    <article
      data-testid={`tutorial-step-${step.n}`}
      className={`grid md:grid-cols-2 gap-6 md:gap-12 items-center ${
        reverse ? "md:[&>*:first-child]:order-2" : ""
      }`}
    >
      {/* Image(s) — visually FIRST on desktop (or alternating), AFTER text on mobile */}
      <div className="space-y-3 order-2 md:order-none">
        {step.images.map((src, i) => (
          <Screenshot key={`${step.n}-${i}`} src={src} label={step.displayLabel || `Pasul ${step.n}`} />
        ))}
      </div>

      {/* Text — FIRST on mobile, default position on desktop */}
      <div className="order-1 md:order-none">
        <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-black text-white text-[10px] font-bold uppercase tracking-[0.16em]">
          {step.displayLabel || `Pasul ${step.n}`}
        </span>
        <h2 className="mt-3 font-display text-2xl sm:text-[26px] font-extrabold text-black leading-tight tracking-tight">
          {step.title}
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-black/70">
          {step.desc}
        </p>

        {step.badges && step.badges.length > 0 && (
          <ul className="mt-4 flex flex-wrap gap-2">
            {step.badges.map((b) => (
              <li
                key={b}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border border-[#C9A24A]/40 text-[12px] font-semibold text-black"
              >
                <CheckCircle2 className="w-3.5 h-3.5 text-[#C9A24A]" />
                Recomandat: {b}
              </li>
            ))}
          </ul>
        )}

        {step.checklist && step.checklist.length > 0 && (
          <ul className="mt-4 space-y-2">
            {step.checklist.map((item) => (
              <li
                key={item}
                className="flex items-start gap-2.5 text-[14px] text-black/75 leading-snug"
              >
                <CheckCircle2 className="w-4 h-4 text-[#C9A24A] mt-0.5 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}

        {step.afterText && (
          <p className="mt-4 text-[14px] text-black/65 leading-relaxed italic">
            {step.afterText}
          </p>
        )}

        {step.callout && (
          <div className="mt-4 flex items-start gap-3 px-4 py-3 rounded-xl bg-[#C9A24A]/[0.08] border border-[#C9A24A]/25">
            <Callout className="w-4 h-4 text-[#C9A24A] mt-0.5 shrink-0" />
            <p className="text-[13px] text-black/75 font-medium leading-snug">
              {step.callout.text}
            </p>
          </div>
        )}
      </div>
    </article>
  );
};

/* ---------- Page ---------- */
export default function TutorialPage() {
  useDocumentMeta(PAGE_TITLE, PAGE_DESC);

  return (
    <div data-testid="tutorial-page" className="min-h-screen bg-white text-black antialiased">
      {/* Hero */}
      <section className="relative overflow-hidden bg-black text-white">
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, #C9A24A 0%, transparent 35%), radial-gradient(circle at 80% 80%, #C9A24A 0%, transparent 35%)",
          }}
        />
        <div className="relative max-w-3xl mx-auto px-6 pt-10 pb-14 sm:pt-14 sm:pb-20">
          <Link
            to="/"
            data-testid="tutorial-back-link"
            className="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.16em] text-white/60 hover:text-white transition"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Înapoi la pagina principală
          </Link>
          <h1 className="mt-6 font-display text-3xl sm:text-5xl font-extrabold tracking-tight leading-tight">
            Ghid complet <span className="text-[#E8C77A]">PU Prime</span>
          </h1>
          <p className="mt-4 text-[15px] sm:text-base text-white/75 max-w-2xl leading-relaxed">
            Urmează pașii de mai jos pentru a crea contul, activa bonusul de
            100% și pregăti contul pentru tranzacționare.
          </p>
          <div className="mt-6 flex flex-wrap gap-2.5">
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/15 text-[12.5px] font-semibold">
              <Clock className="w-3.5 h-3.5 text-white/80" />
              Timp estimat: 5-10 minute
            </span>
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#C9A24A]/15 border border-[#C9A24A]/35 text-[12.5px] font-semibold text-[#E8C77A]">
              <Gift className="w-3.5 h-3.5" />
              Bonus disponibil: 100%
            </span>
          </div>
        </div>
      </section>

      {/* Steps */}
      <section className="max-w-5xl mx-auto px-6 py-12 sm:py-16 space-y-16 sm:space-y-20">
        {STEPS.map((step, idx) => (
          <React.Fragment key={step.n}>
            {step.n === MT5_DIVIDER_BEFORE_STEP && <MT5Divider />}
            <StepRow step={step} reverse={idx % 2 === 1} />
          </React.Fragment>
        ))}
      </section>

      {/* Final completion message — appears between MT5 step 5 and CTA */}
      <section className="px-6">
        <p
          data-testid="tutorial-final-message"
          className="max-w-2xl mx-auto text-center font-display text-lg sm:text-xl font-extrabold text-black tracking-tight pb-12 sm:pb-16"
        >
          Asta e tot, ești pregătit să tranzacționezi acum!
        </p>
      </section>

      {/* Bottom CTA */}
      <section className="px-6 pb-16">
        <div className="max-w-2xl mx-auto rounded-3xl bg-black text-white p-7 sm:p-9 relative overflow-hidden">
          <span
            aria-hidden
            className="absolute left-0 top-0 bottom-0 w-[3px] bg-[#C9A24A]"
          />
          <h3 className="font-display text-xl sm:text-2xl font-extrabold tracking-tight">
            Ești gata să începi?
          </h3>
          <p className="mt-2 text-[14px] text-white/70 leading-relaxed">
            Deschide-ți cont prin link-ul meu și activează bonusul de 100% la depunere.
          </p>
          <button
            type="button"
            onClick={() => {
              gaEvent("tutorial_cta_click", { source: "tutorial_bottom" });
              handleAffiliateClick("tutorial_bottom");
            }}
            data-testid="tutorial-cta"
            className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-black font-bold text-[14px] hover:bg-[#E8C77A] transition-colors"
          >
            Creează cont PU Prime
            <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      <TutorialFooter />
    </div>
  );
}

/* ---------- MT5 section divider ---------- */
const MT5Divider = () => (
  <div
    data-testid="mt5-divider"
    className="relative max-w-3xl mx-auto text-center py-2"
  >
    <div className="flex items-center gap-4">
      <span aria-hidden className="flex-1 h-px bg-black/10" />
      <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black text-white text-[11px] font-bold uppercase tracking-[0.18em]">
        <span className="w-1.5 h-1.5 rounded-full bg-[#C9A24A]" />
        MetaTrader 5
      </span>
      <span aria-hidden className="flex-1 h-px bg-black/10" />
    </div>
    <h2 className="mt-5 font-display text-2xl sm:text-3xl font-extrabold text-black tracking-tight leading-tight">
      Conectarea contului la MetaTrader 5
    </h2>
    <p className="mt-2 text-[14px] text-black/55 leading-relaxed max-w-xl mx-auto">
      După ce ai contul activ, verificat și bonusul creditat, următorul pas este să conectezi contul PU Prime în aplicația MetaTrader 5.
    </p>
  </div>
);

/* ---------- Footer (same legal links as homepage) ---------- */
const TutorialFooter = () => (
  <footer data-testid="tutorial-footer" className="px-5 pb-10 pt-6 border-t border-black/[0.06]">
    <div className="max-w-md mx-auto text-center">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] font-semibold text-black/55">
        <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-black transition">Privacy Policy</Link>
        <span className="text-black/20">·</span>
        <Link to="/terms-and-conditions" data-testid="footer-terms" className="hover:text-black transition">Terms &amp; Conditions</Link>
        <span className="text-black/20">·</span>
        <Link to="/gdpr-cookies" data-testid="footer-gdpr" className="hover:text-black transition">GDPR / Cookies</Link>
        <span className="text-black/20">·</span>
        <Link to="/risk-disclaimer" data-testid="footer-risk" className="hover:text-black transition">Risk Disclaimer</Link>
      </div>
      <p className="mt-5 text-[11px] text-black/50 leading-relaxed max-w-sm mx-auto">
        Tradingul implică risc și poate duce la pierderea capitalului investit.
        Informațiile prezentate sunt educative și nu reprezintă consultanță
        financiară sau promisiune de profit.
      </p>
      <p className="mt-4 text-[11px] text-black/40">© Payouts By Ceo</p>
    </div>
  </footer>
);
